// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"123":"65ea55e0","8229":"9da6db1e"}[chunkId] || chunkId) + "." + {"123":"3b5e50479e36c7ad","684":"0f168a9769506386","4138":"34b7007df330ac9e","8229":"8e45e9ffd8c41226"}[chunkId] + ".js";
};